import { useEffect, useState } from "react";
import { createBingoSession, createBingoVisitId } from "./fallBingoStorage";

export default function useFallBingoProgress(userId, defaultName) {
  // The page is keyed by uid. Keep one visit ID across Strict Mode effects.
  const [session] = useState(() => createBingoSession(userId, defaultName, createBingoVisitId()));
  const [state, setState] = useState(() => session.snapshot());
  useEffect(() => session.start(setState), [session]);
  return { ...state, dispatch: session.dispatch, retry: session.retry };
}
